import { Injectable } from '@angular/core';
// import { InformationRoutingBreadcrumbs } from '../Pages/organization/transportmanger/information/information.routing';
// import { RequestRoutingBreadcrumb } from '../Pages/organization/transportmanger/requests/request.routing';
// import { supportDeskBreadCrumbs } from '../Pages/organization/transportmanger/support-desk/suportdesk.routing.component';
// import { ReportsRoutingBreadcrumb } from './../Pages/organization/transportmanger/reports/reports.routing';
// import { CampaignsRoutingBreadcrumbs } from '../Pages/organization/transportmanger/campaigns/campaigns.routing';
// import { SosPanelRoutingBreadcrumbs } from '../Pages/organization/transportmanger/sos-panel/sos-panel.routing';
// import { ManualRosteringRoutingBreadcrumbs } from '../Pages/organization/transportmanger/rostering/manual-rostering/manual-rostering.routing';
// import { RosteringRoutingBreadcrumb } from '../Pages/organization/transportmanger/rostering/rostering.routing';
// import { RouteRoutingBreadcrumb } from '../Pages/organization/transportmanger/rostering/routes/routes.routing';
// import { TransportBreadCrubsMenu } from '../Pages/organization/transportmanger/transportmanger.routing'

@Injectable()

export class BreadcrumbService {
     getMenu() {
          const menu = [

               {
                    name: 'Organization',
                    path: '/organization',
                    children: [
                         {
                              name: 'Transport-manager',
                              path: '/transport-manager',
                              children: [

                                   {    name: 'Home', path: '/dashboard',
                                   },
                                   // { name: 'SOS Dashboard', path: '/sospanel' },
                                   // {
                                   //      name: 'Reports', path: '/reports',
                                   //      children: ReportsRoutingBreadcrumb
                                   // },
                                   // {
                                   //      name: 'Support-desk', path: '/support-desk',
                                   //      children: supportDeskBreadCrumbs
                                   // },
                                   // {
                                   //      name: 'Informaton', path: '/information-component',

                                   // },
                                   // {
                                   //      name: 'Information', path: '/information',
                                   //      children: InformationRoutingBreadcrumbs
                                        /* children: [
                                             {
                                                  name: 'Vendor', path: '/vendor',
                                                  children: [
                                                       {
                                                            name: 'Dashboard', path: '/view-vendor'
                                                       },
                                                       {
                                                            name: 'View', path: '/single-view-vendor',

                                                       }
                                                  ]
                                             }, {
                                                  name: 'Vehicle', path: '/vehicle',
                                                  children: [
                                                       { name: 'View', path: '/view-vehicle' },
                                                       { name: 'Create', path: '/create-vehicle' },
                                                       { name: 'Edit', path: '/edit-vehicle' },
                                                       { name: 'Single-View', path: '/single-view-vehicle' },
                                                  ]
                                             },
                                             {
                                                  name: 'Driver', path: '/driver',
                                                  children: [
                                                       { name: 'View', path: '/view-driver' },
                                                       { name: 'Create', path: '/add-driver' },
                                                       { name: 'Edit', path: '/edit-driver' },
                                                       { name: 'Single-View', path: '/single-view-driver' },
                                                  ]
                                             },
                                             {
                                                  name: 'Organization', path: '/orgInfo',
                                                  children: 
                                                  [   
                                                       {
                                                            name: 'Employee', path: '/employee',
                                                            children: [
                                                                 {
                                                                      name: 'View', path: '/view-employee'
                                                                 },
                                                                 {
                                                                      name: 'Create', path: '/add-empolyee'
                                                                 }
                                                            ]
                                                       },
                                                       {
                                                            name: 'Shift', path: '/shift',
                                                            children: [
          
                                                                 { name: 'Create', path: '/add-shift' },
                                                                 { name: 'View', path: '/list-shift' },
                                                                 { name: 'Edit', path: '/edit-shift' },
                                                            ]
                                                       }
                                                       ,
                                                       {
                                                            name: 'Branch', path: '/branch',
                                                            children: [
          
                                                                 { name: 'Create', path: '/add-branch' },
                                                                 { name: 'View', path: '/view-branch' },
                                                                 { name: 'Edit', path: '/edit-branch' },
                                                            ]
                                                       },
                                                       {
                                                            name: 'Parking', path: '/parking',
                                                            children: [
          
                                                                 { name: 'Create', path: '/add-parking' },
                                                                 { name: 'View', path: '/view-parking' },
                                                                 { name: 'Edit', path: '/edit-parking' },
                                                            ]
                                                       }
                                                  ]
                                             },
                                        ] */
                                   // },
                                   // {
                                   //      name: 'Request', path: '/request',
                                   //      children: RequestRoutingBreadcrumb
                                   // },
                                   // {
                                   //      name: 'Campaigns', path: '/campaigns',
                                   //      children: CampaignsRoutingBreadcrumbs
                                   // },                                   
                                   // {
                                   //      name: 'Route / Rostering', path: '/rostering',
                                   //      children: [
                                   //           {
                                   //                name: 'Rostering', path: '/rostering', children: [

                                   //                ]
                                   //           },
                                   //           // { name: 'Manual', path: '/manual', children: ManualRosteringRoutingBreadcrumbs },
                                   //           // { name: 'Routes', path: '/routes', children: RouteRoutingBreadcrumb },
                                   //           { name: 'Semi-automatic', path: '/semi-automatic', children: [] },
                                   //      ]
                                   // },
                                   // {
                                   //      name:'SOS-Panel', path:'/sospanel',
                                   //      children : SosPanelRoutingBreadcrumbs
                                   // },
                              ]
                         }
                    ]
               },

          ];

          return menu;
     }



}
